module.exports = __webpack_public_path__ + "static/media/table2.94471879.jpg";